import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxDropdown } from "@axess/limestone";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import { CustomerLessonProperties, InitCustomerProps } from "../../Account/CustomerLessonProperties";

@ModuleName("CompPackBookingPersonOptions")
export class CompPackBookingPersonOptions implements AxInit {
    protected axLoading: AxLoading;
    protected isTextInput: boolean;

    protected complexPackageBookingOptions: ComplexPackageBookingOptions;

    protected personDropdown: AxDropdown = new AxDropdown();
    protected genderDropdown: AxDropdown = new AxDropdown();
    protected heightDropdown: AxDropdown = new AxDropdown();
    protected weightDropdown: AxDropdown = new AxDropdown();
    protected shoeSizeDropdown: AxDropdown = new AxDropdown();

    private _customerLessonProps: CustomerLessonProperties = new CustomerLessonProperties();
    
    AxInit(init: initData): void {
        this.axLoading = new AxLoading();
        this.isTextInput = init.isTextInput;

        this.complexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");

        this.personDropdown.init('.prod_selection__person-selection .ax-dropdown', {
            multiSelect: false,
            searchBar: false,
            onSelect: (_, value) => {
                this.loadPersonPartialAfterSelect(value as string);
            }
        });
        this.personDropdown.resetSelection();

        this.complexPackageBookingOptions.dropDowns.push(this.personDropdown);
    }

    setLessonPropsToBookingOptions() {
        this.complexPackageBookingOptions.bookingValues.lessonAllergies = this._customerLessonProps.allergies;
        this.complexPackageBookingOptions.bookingValues.lessonLanguages = this._customerLessonProps.languages;
        this.complexPackageBookingOptions.bookingValues.lessonMedicals = this._customerLessonProps.medicalStates;
        this.complexPackageBookingOptions.bookingValues.lessonLevels = this._customerLessonProps.lessonLevels;
    }

    // loadPersonPartialAfterSelect
    loadPersonPartialAfterSelect(value: string) {
        const accountId = Number(value);
        this.complexPackageBookingOptions.bookingValues.accountId = accountId;

        this.loadPersonPartial(accountId);
    }

    // loadPersonPartial
    loadPersonPartial(accountId, unitInt = undefined) {
        const data = {
            accountNr: accountId,
            unitInt: unitInt,
        };

        this.axLoading.ShowLoadingIndicator($('#personOptionsHolder')[0]);

        AxessViewer.loadPartialView('/ComplexPackagesBooking/GetPersonOptionsPartial', data, (result) => {
            $('#personOptionsHolder').html(result);
            this.initPersonDataPartial();

            this._customerLessonProps.AxInit(new InitCustomerProps('#lessonPropsHolder', ''));

            this.axLoading.HideLoadingIndicator($('#personOptionsHolder')[0]);
        }, {
            dataType: 'html'
        });
    }

    // reloadPersonPartial
    reloadPersonPartial(unitInt) {
        this.loadPersonPartial(this.complexPackageBookingOptions.bookingValues.accountId, unitInt);
    }

    // initPersonDataPartial
    initPersonDataPartial() {
        // unit selection
        $('input[type=radio][name=DataUnitSystem]').on('change', (e) => {
            const unitInt = $(e.currentTarget).val();
            this.reloadPersonPartial(unitInt);
        });

        // gender
        this.genderDropdown.init('.prod_selection__gender-selection .ax-dropdown', {
            multiSelect: false,
            searchBar: false,
            onSelect: ($parent, value) => {
                this.complexPackageBookingOptions.bookingValues.gender = value as string;
            }
        });
        this.complexPackageBookingOptions.dropDowns.push(this.genderDropdown);

        // height
        if (this.isTextInput) {
            $('[name="height"]').on('keyup',
                (e) => {
                    this.complexPackageBookingOptions.bookingValues.height = Number($(e.target).val());
                });

            $('[name=heightFeet],[name=heightInch]').on('input', e => {

                let feet = parseInt($('[name=heightFeet]').val() as string);
                let inches = parseInt($('[name=heightInch]').val() as string);

                let totalInches = feet * 12;
                totalInches += inches;

                const meters = parseFloat((totalInches / 39.370).toFixed(2));
                this.complexPackageBookingOptions.bookingValues.height = meters;
            });
        } else {
            this.heightDropdown.init('.prod_selection__height-selection .ax-dropdown', {
                multiSelect: false,
                searchBar: false,
                onSelect: (_, value) => {
                    this.complexPackageBookingOptions.bookingValues.height = Number(value);
                }
            });
            this.complexPackageBookingOptions.dropDowns.push(this.heightDropdown);
        }

        // weight
        if (this.isTextInput) {
            $('[name="weight"]').on('keyup', (e) => {
                let weight = parseInt($(e.target).val() as string);

                if ($('[name=DataUnitSystem]:checked').val() === '1') {
                    weight = Math.round(weight / 2.20462);
                }
                this.complexPackageBookingOptions.bookingValues.weight = weight;
            })
        } else {
            this.weightDropdown.init('.prod_selection__weight-selection .ax-dropdown', {
                multiSelect: false,
                searchBar: false,
                onSelect: ($parent, value) => {
                    this.complexPackageBookingOptions.bookingValues.weight = Number(value);
                }
            });
            this.complexPackageBookingOptions.dropDowns.push(this.weightDropdown);
        }

        // shoeSize
        this.shoeSizeDropdown.init('.prod_selection__shoeSize-selection .ax-dropdown', {
            multiSelect: false,
            searchBar: false,
            onSelect: (_, value) => {
                this.complexPackageBookingOptions.bookingValues.shoeSize = Number(value);
            }
        });
        this.complexPackageBookingOptions.dropDowns.push(this.shoeSizeDropdown);

        // skillLevel selection
        const userSkillLevel = $('#compPackUserSkillLevel').val();

        if (userSkillLevel != 0) {
            this.complexPackageBookingOptions.bookingValues.skillLevel = Number(userSkillLevel);
            $(`.compPack-skillLevel-pill[data-skillLevelId="${userSkillLevel}"]`).addClass('active ax-fill-primary');
        }

        $('.compPack-skillLevel-pill').on('click', (x) => {
            const $target = $(x.delegateTarget);

            $target.parent().find('.active').each((i, e) => {
                this.toggleQuestionChip($(e));
            });

            this.toggleQuestionChip($target);

            const skillLevelId = $target.attr('data-skillLevelId');
            this.complexPackageBookingOptions.bookingValues.skillLevel = Number(skillLevelId);
        });

        this.setLessonPropsToBookingOptions();
    }

    toggleQuestionChip($target: JQuery<HTMLElement>) {
        $target.toggleClass('active').toggleClass('ax-fill-primary');
        $target.find('i.las').toggleClass('color-white').toggleClass('ax-color-primary');
        $target.find('i.lar').toggleClass('color-white').toggleClass('ax-color-primary--light');
    }
}

export interface initData {
    isTextInput: boolean;
}
